export const checksums = {
  "pages": "co5uEtQWWA",
  "articles": "3bkY8cxdk6",
  "categories": "QNOt47KSiD",
  "pageSlugs": "N2TH3CZEe6",
  "blogSlugs": "KoGTDfEYFt"
}

export const tables = {
  "pages": "_content_pages",
  "articles": "_content_articles",
  "categories": "_content_categories",
  "pageSlugs": "_content_pageSlugs",
  "blogSlugs": "_content_blogSlugs",
  "info": "_content_info"
}

export default {
  "pages": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "block": "json"
    }
  },
  "articles": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "block": "json"
    }
  },
  "categories": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json"
    }
  },
  "pageSlugs": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json"
    }
  },
  "blogSlugs": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json"
    }
  },
  "info": {
    "fields": {}
  }
}